import { Card, type SxProps, type Theme } from '@mui/material';
import type { ReactNode, MouseEventHandler } from 'react';

interface AppCardProps {
    children: ReactNode;
    id?: string;
    'data-testid'?: string;
    'aria-busy'?: boolean;
    sx?: SxProps<Theme>;
    onClick?: () => void;
    onMouseEnter?: MouseEventHandler;
    onMouseLeave?: MouseEventHandler;
}

export function AppCard({ children, id, 'data-testid': testId, 'aria-busy': busy, sx, onClick, onMouseEnter, onMouseLeave }: AppCardProps) {
    return (
        <Card
            id={id}
            data-testid={testId}
            aria-busy={busy}
            sx={{
                boxShadow: 1,
                borderRadius: '4px',
                bgcolor: 'background.paper',
                overflow: 'hidden',
                ...(onClick && {
                    cursor: 'pointer',
                    transition: 'box-shadow 0.15s ease',
                    '&:hover': {
                        boxShadow: 3,
                    },
                }),
                ...sx,
            }}
            onClick={onClick}
            onMouseEnter={onMouseEnter}
            onMouseLeave={onMouseLeave}
        >
            {children}
        </Card>
    );
}